import '@vfde-brix/promo-teaser/dist/styles.css';
import { createPromoTeaserComponent } from '@vfde-brix/promo-teaser';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-promo-teaser', createPromoTeaserComponent, NO_PATTERN_BUSINESS_LOGIC);
